module.exports = __webpack_public_path__ + "static/media/Dobro - map icons_Tvornica šećera Osijek icon (1).6d8192f9.svg";